import { ArrowRight } from "lucide-react";

export function PlanTransition({ currentPlan, newPlan, isYearly, getPlanName, t }) {
    return (
        <div className="flex items-center gap-3">
            <PlanBox label={t("billing.upgradeConfirm.currentPlan") || "Current"} name={getPlanName(currentPlan)} />
            <ArrowRight className="w-5 h-5 text-indigo-400 flex-shrink-0" />
            <PlanBox label={t("billing.upgradeConfirm.newPlan") || "New"} name={getPlanName(newPlan)} highlighted />
        </div>
    );
}

function PlanBox({ label, name, highlighted }) {
    return (
        <div className={`flex-1 rounded-lg p-3 border text-center ${highlighted ? "border-indigo-300 bg-indigo-50" : "border-gray-200 bg-gray-50"}`}>
            <div className="text-xs text-gray-500 mb-1">{label}</div>
            <div className={`font-semibold text-sm ${highlighted ? "text-indigo-700" : "text-gray-900"}`}>{name}</div>
        </div>
    );
}

export function PriceSummary({ currentPrice, newPrice, priceDiff, isIncrease, isYearly, isDowngrade, t }) {
    const period = isYearly ? (t("billing.upgradeConfirm.yr") || "yr") : (t("billing.upgradeConfirm.mo") || "mo");
    const currentTotal = isYearly ? (parseFloat(currentPrice) * 12).toFixed(2) : currentPrice;
    const newTotal = isYearly ? (parseFloat(newPrice) * 12).toFixed(2) : newPrice;
    const diffTotal = isYearly ? (Math.abs(parseFloat(priceDiff)) * 12).toFixed(2) : Math.abs(parseFloat(priceDiff)).toFixed(2);
    const refundUrl = t("billing.upgradeConfirm.refundUrl") || "https://www.agentui.ai/en/refund/";

    return (
        <div className="bg-gray-50 rounded-xl p-4 space-y-2">
            <div className="flex justify-between text-sm">
                <span className="text-gray-600">{t("billing.upgradeConfirm.currentPrice") || "Current price"}</span>
                <span className="text-gray-900 font-medium">${currentTotal}/{period}</span>
            </div>
            <div className="flex justify-between text-sm">
                <span className="text-gray-600">{t("billing.upgradeConfirm.newPrice") || "New price"}</span>
                <span className="text-gray-900 font-medium">${newTotal}/{period}</span>
            </div>
            {isYearly && (
                <div className="flex justify-between text-xs text-gray-400">
                    <span></span>
                    <span>${newPrice}/{t("billing.upgradeConfirm.mo") || "mo"} x 12</span>
                </div>
            )}
            <div className="border-t border-gray-200 pt-2 flex justify-between text-sm font-semibold">
                <span className="text-gray-700">{t("billing.upgradeConfirm.difference") || "Difference"}</span>
                <span className={isIncrease ? "text-red-600" : "text-emerald-600"}>
                    {isIncrease ? "+" : "-"}${diffTotal}/{period}
                </span>
            </div>
            {isDowngrade && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-2">
                    <p className="text-xs text-amber-800">
                        {t("billing.upgradeConfirm.noRefundDisclaimer") || "Payments are non-refundable. The downgrade will take effect at the end of your current billing period."}{" "}
                        <a href={refundUrl} target="_blank" rel="noopener noreferrer" className="underline font-medium hover:text-amber-900">
                            {t("billing.upgradeConfirm.refundPolicy") || "Refund Policy"}
                        </a>
                    </p>
                </div>
            )}
        </div>
    );
}
